import React, { useContext } from 'react'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'
import { FormBaseErrorMessage, FormBaseFieldGroup, FormBaseRow } from 'components/Form/Form.styles'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { Field, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormFieldBlock } from 'routes/Transactions/Transactions.styles'
import { TicketsApiClient } from 'utils/api/ticketsApi'

type Props = OuterProps

const InformedComplianceModalFormUI: React.FC<FormikProps<InformedComplianceValues> & Props> = ({
  errors,
  ...props
}) => {
  return (
    <ConfirmationModal
      yesButtonText='Proceed'
      cancelButtonText='Cancel'
      onYes={props.handleSubmit}
      onCancel={props.onCancel}
      visible={props.visible}
      renderTitle={
        <div>
          <p>Please specify a reason</p>
          <FormFieldBlock>
            <FormBaseRow>
              <FormBaseFieldGroup>
                <Field
                  name='ticketDescriptionReason'
                  component='textarea'
                  rows={3}
                  maxLength={130}
                  required
                  data-test='ticket-description-reason-field'
                />
              </FormBaseFieldGroup>
            </FormBaseRow>
            {errors?.ticketDescriptionReason && (
              <FormBaseErrorMessage>{errors.ticketDescriptionReason}</FormBaseErrorMessage>
            )}
          </FormFieldBlock>
        </div>
      }
    />
  )
}

interface InformedComplianceConfirmationModalProps {
  ticketsApiClient: TicketsApiClient
  clientId?: string
  onCancel: () => void
  visible: boolean
}

export const InformedComplianceConfirmationModal: React.FC<
  InformedComplianceConfirmationModalProps
> = (props) => {
  const setToast = useContext(ToastContext)

  const handleInformedComplianceProceed = async (ticketDescriptionReason: string) => {
    if (props?.clientId) {
      await props.ticketsApiClient.addTicketHighRiskClients({
        clientId: props.clientId,
        comment: ticketDescriptionReason,
      })
      setToast(successToast('Ticket has been successfully created.'))
      props.onCancel()
    }
  }

  return <InformedComplianceModalForm {...props} onSubmit={handleInformedComplianceProceed} />
}

interface OuterProps extends InformedComplianceConfirmationModalProps {
  onSubmit: (ticketDescriptionReason: string) => void
}

interface InformedComplianceValues {
  ticketDescriptionReason: string
}

const InformedComplianceModalForm = withFormik<OuterProps, InformedComplianceValues>({
  mapPropsToValues: () => {
    return {
      ticketDescriptionReason: '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values.ticketDescriptionReason)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<InformedComplianceValues> = {}
    if (!values.ticketDescriptionReason) {
      errors.ticketDescriptionReason = 'Required'
    }
    return errors
  },
  enableReinitialize: true,
  isInitialValid: false,
})(InformedComplianceModalFormUI)
